import { customFieldLabelFor, type CustomFieldDefinition } from '@erp/shared';

export function customFieldLabel(definition: CustomFieldDefinition, language: string): string {
  return customFieldLabelFor(definition, language);
}
